export const demoData = {
  configuration: {
    system: "System / Service",
    systemOptions: {
      Shopware5: "Shopware 5",
      Test: "Test"
    },
    dataTypeShopware5: "Shopware 5 Ressource",
    dataTypeShopware5Options: {
      Address: "Adresse",
      Article: "Artikel",
      Category: "Kategorie",
      Customer: "Kunde",
      Order: "Bestellung"
    },
    quantity: "Total quantity of datasets to be created"
  },
  input: {
    articles: "Input articles",
    customers: "Input customers"
  }
};
